import type { AppData } from "../../shared/types";
import { isKickedOffAwaitingData } from "../lib/fixtures";

export class NotReadyError extends Error {
  constructor() {
    super("API not ready");
    this.name = "NotReadyError";
  }
}

export const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");

export async function fetchAppData(): Promise<AppData> {
  const res = await fetch(`${API_BASE}/api/data`, { headers: { Accept: "application/json" } });
  if (res.status === 404) throw new NotReadyError();
  if (!res.ok) throw new Error(`Failed to fetch app data: ${res.status}`);
  return res.json();
}

export function getPollIntervalMs(appData: AppData | null): number {
  if (!appData) return 60_000;
  if (appData.liveFixtures.length > 0) return 30_000;
  if (appData.allFixtures.some((f) => isKickedOffAwaitingData(f))) return 30_000;

  const nextKickoffMs = appData.upcomingHeadToHeads
    .map((f) => new Date(f.dateUtc).getTime() - Date.now())
    .filter((ms) => ms > 0)
    .sort((a, b) => a - b)[0];

  if (nextKickoffMs !== undefined && nextKickoffMs < 30 * 60_000) {
    return 60_000;
  }
  return 5 * 60_000;
}
